import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { customerConstants } from "../../../../../../../constants";
import copyIcon from "../../../../../../../assets/icons/copy-icon.svg";
import SelectField from "../../../../../../../shared/components/Fields/SelectField";
import SectionHeader from "../../../../../../../shared/components/Events/SectionHeader";
import ViewGallery from "../../../../../../../shared/components/ViewGallery/ViewGallery";
import { customerDashboardActions } from "../../../../../../../redux/actions/customerDashboard.actions";

const AccessGallery = ({
  getMyEventsAccessGallery,
  deleteFromGallery,
  lockFromGallery,
  favoriteClip,
}) => {
  const { t } = useTranslation("common");

  const { eventId, groupEventId } = useParams();
  const [files, setFiles] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState({ id: eventId });

  const eventUrl = `${window.location.protocol}//${window.location.host}/SharedGallery?eventid=${selectedEvent?.id}`;

  useEffect(() => {
    getMyEventsAccessGallery(eventId, null, setEventList);
    // eslint-disable-next-line
  }, []);

  const copyToClipboard = async (e) => {
    e.preventDefault();
    await navigator.clipboard.writeText(eventUrl);
    alert("Link Copied");
  };

  const handleDelete = async () => {
    const filesToDeleteFromServer = selectedFiles.filter((file) => file.id);
    const filesToRemoveLocally = selectedFiles.filter((file) => !file.id);

    if (filesToDeleteFromServer.length > 0) {
      const idArray = filesToDeleteFromServer.map((file) => file.id);
      deleteFromGallery({ ids: idArray }, setSelectedFiles, () =>
        getMyEventsAccessGallery(eventId, null, setEventList)
      );
    }

    if (filesToRemoveLocally.length > 0) {
      setFiles((prevFiles) =>
        prevFiles.filter((file) => !filesToRemoveLocally.includes(file))
      );
    }

    if (
      filesToRemoveLocally.length > 0 &&
      filesToDeleteFromServer.length === 0
    ) {
      setSelectedFiles([]);
    }
  };

  const handleLock = () => {
    const filesToLock = selectedFiles.filter((file) => file.id);

    if (filesToLock.length > 0) {
      const galleryFiles = filesToLock.map((file) => ({
        Id: file.id,
        IsLocked: file.isLocked ? false : true,
      }));

      lockFromGallery({ GalleryFiles: galleryFiles }, () =>
        getMyEventsAccessGallery(eventId, null, setEventList)
      );
    }

    setSelectedFiles([]);
  };

  const favoriteClipHandle = (id) => {
    favoriteClip(id, () =>
      getMyEventsAccessGallery(eventId, null, setEventList)
    );
  };

  useEffect(() => {
    if (!eventList?.length) return;

    if (eventList.length > 1) {
      const options = eventList.map(({ id, eventName }) => ({
        id: id,
        name: eventName,
        label: `${eventName} (ID: ${id})`,
        value: id,
      }));

      setEventOptions(options);

      const selected = options.find((opt) => opt.id == selectedEvent.id);
      setSelectedEvent(selected);

      const matchedEvent = eventList.find(
        (event) => event.id == selectedEvent.id
      );
      setFiles(matchedEvent?.gallery || []);
    } else {
      setFiles(eventList[0].gallery);
    }
    // eslint-disable-next-line
  }, [eventList]);

  const handleSelect = (e) => {
    setSelectedEvent(e);
    const matchedEvent = eventList.find((event) => event.id === e.id);
    setFiles(matchedEvent?.gallery || []);
  };

  return (
    <div className="container access-gallery px-0">
      {eventList?.length > 0 && (
        <SectionHeader
          eventId={eventId}
          groupId={groupEventId}
          itemCount={eventList?.length || 0}
          isGroup={eventList?.length > 1}
          title={
            eventList?.length > 1
              ? eventList[0]?.eventGroup?.name
              : eventList[0]?.eventName
          }
          className="px-4"
        />
      )}

      <div className="px-4 py-2">
        {eventList?.length > 1 && (
          <div className="col-md-6 col-12 p-0">
            <SelectField
              options={eventOptions}
              id="select-event"
              label="select an event:"
              placeholder="select an event"
              value={selectedEvent}
              setValue={handleSelect}
            />
          </div>
        )}
        <div className="row my-3">
          <div className="col px-0">
            <p className="p-0 m-0 mb-2 text fw-600 text-dark">
              share this gallery with your guests
            </p>
            <div
              className="col-12 px-0 d-flex align-items-center cursor-pointer"
              onClick={copyToClipboard}
            >
              <p className="mb-0 pr-3 text underline">{eventUrl}</p>
              <img src={copyIcon} alt="" className="ms-2 cursor-pointer" />
            </div>
          </div>
        </div>
        {files?.length > 0 ? (
          <div className="row">
            <div className="col px-0">
              <ViewGallery
                isAllowLock
                isTabsDisplay
                showHearthIcon
                isModalAllowed
                isAllowDownload
                files={files}
                setFiles={setFiles}
                handleLock={handleLock}
                handleDelete={handleDelete}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                favoriteClipHandle={favoriteClipHandle}
              />
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-start mt-4 access-gallery-fonts">
            <p>{t("no_image")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getMyEventsAccessGallery: (eventId, groupEventId, setEventList) =>
    dispatch(
      customerDashboardActions.myEventsAccessGallery(
        eventId,
        groupEventId,
        setEventList,
        customerConstants.ACCESS_GALLERY_CALL
      )
    ),
  deleteFromGallery: (dataObj, setSelectedFiles, onSuccess) =>
    dispatch(
      customerDashboardActions.deleteFromGallery(
        dataObj,
        setSelectedFiles,
        onSuccess
      )
    ),
  lockFromGallery: (data, onSuccess) =>
    dispatch(customerDashboardActions.lockFromGallery(data, onSuccess)),
  favoriteClip: (clipId, getUpdatedData) =>
    dispatch(customerDashboardActions.favoriteClip(clipId, getUpdatedData)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccessGallery));
